<template>
<apexchart type="bar" height="150" :options="chartOptions" :series="series"></apexchart>
</template>
<script>
import VueApexCharts from 'vue-apexcharts'
export default {
  name: 'energydaily',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    block: Object,
    default: {}
  },
  watch: {
    block() {
      this.fetchEnergy()
    }
  },
  methods: {
    async fetchEnergy() {
      console.log('Energy fetchCounts')
      let payload = {
        blockid: this.block.blockid,
        type: this.block.type
      }
      const response = await this.$http.get(`/energy?funcname=bymonth&meterid=${payload.blockid}&metertype=${payload.type}`)

      const used = response.data.map((val) => {
        return {
          y: val.value,
          x: val.timestamp
        }
      })
      const lost = response.data.map((val) => {
        return {
          y: val.lost,
          x: val.timestamp
        }
      });
      this.series = [{name: 'Usada', data: used}, {name: 'Perdida', data: lost}]
      this.categories = response.data.map((val) => val.timestamp)
    },
  },

  data() {
    return {
      categories: [],
      series: [{data: []}, {data: []}],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 150,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: false
          }
        },
        colors: ["#68D138", "#D93D39"],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          type: 'datetime'
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        }
      },
    }
  }
}
</script>
